import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/Home1.jpg";
import HeroImage from "../../assets/images/Charity1.jpg";
import waterMarkImage from "../../assets/images/Charity2.jpg";

import { useNavigate } from "react-router-dom";
import "../../css/pages/homePage.css";
import "../../css/components/CharityGrid.css";
import imageOne from "../../assets/images/Charity3.jpg";
import imageTwo from "../../assets/images/Charity4.jpg";
import imageThree from "../../assets/images/Charity5.jpg";
import imageFour from "../../assets/images/Charity6.jpg";

// import { ReactComponent as InvestmentsIcon } from "../../assets/icons/Investments.svg";
// import { ReactComponent as PensionsIcon } from "../../assets/icons/Pensions.svg";
// import { ReactComponent as ProtectionIcon } from "../../assets/icons/Protection.svg";
// import { ReactComponent as EquityReleaseIcon } from "../../assets/icons/EquityRelease.svg";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import ContactUsPage from "./ContactUsPage";

const CharityPage = () => {
  const navigate = useNavigate();

  // Charity cards data
  const charities = [
    {
      title: "Our Sponsored Charity",
      image: imageOne,
      heading: "Supporting families facing childhood cancer.",
      body: (
        <>
          Candlelighters is a charity bringing light and hope to families facing
          childhood cancer across Yorkshire, providing emotional, practical and
          financial support from diagnosis and for as long as it is needed,
          while also funding research into childhood cancers.
        </>
      ),
    },
    {
      title: "The Impact",
      subtitle: "CHARITY",
      image: imageTwo,
      heading: "",
      body: (
        <>
          Each year, more than 150 children in Yorkshire are diagnosed with
          cancer. Candlelighters helps them and their families, not only for the
          child but for the entire family. The journey is never easy; it can be
          challenging, emotional, and frightening.
          <br />
          Candlelighters has formed 50 years ago to support families through
          every step of their journey, ensuring that no family faces cancer
          alone.
        </>
      ),
    },
    {
      title: "Our Support",
      subtitle: "CHARITY",
      image: imageThree,
      heading: "",
      body: (
        <>
          Candlelighters’ mission is to bring light to every family affected by
          childhood cancer across Yorkshire. We are proud to support their work
          and to champion their commitment to improving outcomes and quality of
          life for children with cancer.
        </>
      ),
    },
    {
      title: "Our Commitment",
      subtitle: "CHARITY",
      image: imageFour,
      heading: "",
      body: (
        <>
          We are proud to support Candlelighters and to be part of the community
          that helps provide hope, support, and essential services to families
          when they need it most.
        </>
      ),
    },
  ];

  return (
    <div className="home-page">
      <Hero
        title="Candlelighters"
        subtitle="CHARITY"
        backgroundImage={HeroImage} // Optionally add a hero image
        titleAlign="center"
        subtitleAlign="center"
        waterMarkImage={waterMarkImage}
      />

      <section className="home-about-section">
        <div className="home-container">
          {charities.map((charity, index) => (
            <div
              key={index}
              className={`charity-card ${
                index % 2 === 0 ? "charity-card-reverse" : ""
              }`}
            >
              <div className="page-card-image">
                <img src={charity.image} alt={charity.title} />
              </div>

              <div className="page-card-content">
                <div className="nav primary">CHARITY</div>
                {charity.title && (
                  <h2 className="primary">
                    {charity.title.split(" ")[0]}{" "}
                    <span className="italic-text">
                      {charity.title.split(" ")[1]}{" "}
                      {charity.title.split(" ")[2]}
                    </span>
                  </h2>
                )}
                <div className="divider primary align-left" />
                <div className="content-semibold primary">
                  {charity.heading}
                </div>
                <div className="content primary">{charity.body}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          {/* <strong>Please Note:</strong> The value of investments and pensions
          can fall as well as rise and you may get back less than you invested. */}
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default CharityPage;
